/**
 * Bold the label at the start of each product specification list item.
 *
 * Specifications are managed as rich text, so merchants can enter plain text
 * such as "Capacity: 300L" without having to format every label by hand.
 */
(() => {
  if (window.productSpecLabelsInitialized) return;
  window.productSpecLabelsInitialized = true;

  // Shopify rich-text metafields can render specifications as either list
  // items or paragraphs, depending on how the content was entered.
  const itemSelector = [
    '.product-specs .modal__content li',
    '.product-specs .modal__content p'
  ].join(', ');

  const boldLabel = (item) => {
    if (item.dataset.specLabelFormatted === 'true') return;

    const walker = document.createTreeWalker(item, NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        if (node.nodeType === Node.ELEMENT_NODE) {
          return node.tagName === 'BR' ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
        }

        return node.parentElement?.closest('script, style')
          ? NodeFilter.FILTER_REJECT
          : NodeFilter.FILTER_ACCEPT;
      }
    });
    let lineStart = true;
    let node;

    while ((node = walker.nextNode())) {
      if (node.nodeName === 'BR') {
        lineStart = true;
        continue;
      }
      if (!lineStart || !node.data.trim()) continue;

      const colonIndex = node.data.indexOf(':');
      if (colonIndex === -1) {
        lineStart = false;
        continue;
      }

      let valueTextNode;
      if (colonIndex < node.data.length - 1) {
        valueTextNode = node.splitText(colonIndex + 1);
      }

      if (!node.parentElement?.closest('strong, b')) {
        const strong = document.createElement('strong');
        node.parentNode.insertBefore(strong, node);
        strong.appendChild(node);
      }

      if (valueTextNode?.data && !/^\s/.test(valueTextNode.data)) {
        valueTextNode.data = ` ${valueTextNode.data}`;
      }

      lineStart = false;
    }

    item.dataset.specLabelFormatted = 'true';
  };

  const formatLabels = (root = document) => {
    if (root.nodeType !== Node.ELEMENT_NODE && root !== document) return;

    if (root.matches?.(itemSelector)) boldLabel(root);
    root.querySelectorAll?.(itemSelector).forEach(boldLabel);
  };

  formatLabels();

  // Product content can be replaced when a variant changes or quick view loads.
  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach(formatLabels);
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
